import { sendGet } from "./restUtil";

// Token에 설정된 사용자 정보 반환
export function getUserInfo() {
	let payload = getJwtPayload();
	if (payload === "") return null;
	return {userSeq: payload.sub, userNm: payload.name, userType: payload.type, branchId: payload.branchId};
}
export function hasAdminAuth(userInfo = getUserInfo()) {
	if(userInfo?.userType === "SYSADMIN" || userInfo?.userType === "HEADOFFICE") {
		return true;
	} else {
		return false;
	}
}
function getJwtPayload() {
	const jwt = localStorage.getItem("accessToken");
	if(jwt == null || jwt === "") return "";

	try {
		// 리눅스는 4의 배수를 맞춰 줘야 한다고...
		let targetPart = jwt.split(".")[1];
		targetPart = targetPart.replace(/-/g, '+').replace(/_/g, '/');
		targetPart = targetPart.padEnd(targetPart.length + (4 - targetPart.length % 4) % 4, '=');

		let payload = JSON.parse(
			decodeURIComponent(
				atob(targetPart)
				.split("")
				.map(function (c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				})
				.join("")
			)
		);
		return payload;
	} catch(e) {
		return "";
	}
}

/**
 * 파일 다운로드
 * @param {*} fileSeq 
 */
export async function downloadFile(fileSeq) {
	
	const result = await sendGet("/api/download-file/" + fileSeq);

	if(result.respCode === "SUCCESS") {

		const objectURL = "data:" + result.data.mime + ";base64," + result.data.file;

		let a = window.document.createElement("a");
		a.href = objectURL;
		a.download = result.data.fileNm;

		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
}